module.exports = __webpack_public_path__ + "img/law-serve-nav-icon03.4eceaa8b.png";